export default "__VITE_ASSET__C$JeKzWt__"